export default "__VITE_ASSET__CQ_Jufo6__"